import { Enum } from "./Enum";

export const E_ENQUIRY = Object.freeze({
  MAIN: "/contact-sale-submission",
  MONTHLY_SUMMARY: "/contact-sale-submission/monthly-summary",
  GET_CEA_DETAILS: "/contact-sale-submission/get-cea-details",
  UPDATE: "/contact-sale-submission/:id",
  DETAIL: "/contact-sale-submission/:id",
  PUBLIC: "/contact-sale-submission/public",
  LOGS: "/contact-sale-submission/logs/:id",
  LOGS_BY_TOKEN: "/contact-sale-submission/public/logs",
  ACTION_LOGS: "/contact-sale-submission/action-logs",
  CREATE_ACTION_LOGS: "/contact-sale-submission/action-logs/:id",
  UPDATE_FEEDBACK: (id: string) => `/contact-sale-submission/${id}`,
});

export type E_ENQUIRY = Enum<typeof E_ENQUIRY>;
